import {action, computed, makeObservable, observable, reaction} from "mobx";
import SaporeForm from "../forms/SaporeForm";
import TextField from "../forms/fields/TextField";
import OptionField from "../forms/fields/OptionField";
import GoogleAddressMapFeature from "../components/maps/GoogleAddressMapFeature";
import Jurisdictions from "./Jurisdictions";

export default class LeadDeliverySiteForm extends SaporeForm {
    static newEmpty(feature) {
        return new LeadDeliverySiteForm(feature);
    }

    constructor(feature) {
        const fields = {
            name: new TextField(1, 256, false, ''),
            address: new TextField(1, 256, false, ''),
            jurisdiction: new OptionField(Jurisdictions.names(), true, undefined, ''),
            city: new TextField(1, 128, false, ''),
            postalCode: new TextField(1, 16, false, ''),
        };
        super(fields, null, feature);
        this._mapFeature = new GoogleAddressMapFeature(this, 'address', 'jurisdiction', 'city', 'postalCode', this.jurisdictionOptions());
        this._deliveryZone = null;
        this._deliveryZoneLookUpsCount = 0;
        this._stopLookingUpDeliveryZoneOnMarkerChange = reaction(
            () => this._mapFeature.markerPosition,
            (markerPosition) => feature.lookUpDeliveryZoneOf(this, markerPosition)
        );

        makeObservable(this, {
            _deliveryZone: observable,
            isOutOfZone: computed,
            zoneDescription: computed,
            storeDeliveryZoneOfLookUp: action,
        });
    }

    get mapFeature() {
        return this._mapFeature;
    }

    get isOutOfZone() {
        return this._deliveryZone !== null && this._deliveryZone.isOutOfZone();
    }

    get zoneDescription() {
        if (this._deliveryZone === null) {
            return '';
        }
        if (this._deliveryZone.isOutOfZone()) {
            return 'Fuera de zona de cobertura';
        }
        return `En zona: ${this._deliveryZone.zone()} · reparto ${this._deliveryZone.frequency()}`;
    }

    jurisdictionOptions() {
        return Jurisdictions.options();
    }

    leadDeliverySite() {
        const markerPosition = this._mapFeature.markerPosition;
        const isLocated = markerPosition !== null;
        return {
            ...this.values,
            latitude: isLocated ? String(markerPosition.lat) : '',
            longitude: isLocated ? String(markerPosition.lng) : '',
        };
    }

    startDeliveryZoneLookUp() {
        this._deliveryZoneLookUpsCount += 1;
        return this._deliveryZoneLookUpsCount;
    }

    storeDeliveryZoneOfLookUp(lookUpNumber, deliveryZoneResponse) {
        const isLatestLookUp = lookUpNumber === this._deliveryZoneLookUpsCount;
        if (isLatestLookUp) {
            this._deliveryZone = deliveryZoneResponse;
        }
    }

    updateMultipleFieldsWithValues(fieldUpdates) {
        Object.entries(fieldUpdates).forEach(([fieldName, value]) => {
            const valueIsPresent = value !== undefined && value !== null;
            if (valueIsPresent) {
                this.getFieldByName(fieldName).updateValue(value);
            }
        });
    }

    dispose() {
        this._stopLookingUpDeliveryZoneOnMarkerChange();
    }
}
